<template>
  <li
    v-if="canViewVerticalNavMenuGroup(item)"
    class="nav-item has-sub"
    :class="{
      'open': cekOpen(item),
      'disabled': item.disabled,
      'sidebar-group-active': cekActive(item),
    }"
  >
    <span
      v-if="item.headers"
      class="navigation-header d-block text-capitalize text-body mt-1 mb-0 font-medium-3"
    >{{ t(item.headers) }}</span>
    <b-link
      class="d-flex align-items-center position-relative"
      @click="clickGroup(clicked)"
    >
      <feather-icon :icon="item.icon || 'CircleIcon'" />
      <span class="menu-title text-truncate font-medium-1">{{ t(item.title) }}</span>
      <b-badge
        v-if="item.tag"
        pill
        :variant="item.tagVariant || 'primary'"
        class="mr-1 ml-auto"
      >
        {{ item.tag }}
      </b-badge>
    </b-link>
    <b-collapse
      v-model="opened"
      class="menu-content"
      tag="ul"
    >
      <component
        :is="resolveNavItemComponent(child)"
        v-for="(child, id) in item.children"
        :key="child.header || id"
        ref="groupChild"
        :item="child"
      />
    </b-collapse>
  </li>
</template>

<script>
import { BLink, BBadge, BCollapse } from 'bootstrap-vue'
import { resolveVerticalNavMenuItemComponent as resolveNavItemComponent } from '@core/layouts/utils'
import { useUtils as useI18nUtils } from '@core/libs/i18n'
import { useUtils as useAclUtils } from '@core/libs/acl'
import VerticalNavMenuHeader from '../vertical-nav-menu-header'
import VerticalNavMenuLink from '../vertical-nav-menu-link/VerticalNavMenuLinkCustom.vue'

// Composition Function
// import useVerticalNavMenuGroup from './useVerticalNavMenuGroup'

export default {
  name: 'VerticalNavMenuGroup',
  components: {
    VerticalNavMenuHeader,
    VerticalNavMenuLink,
    BLink,
    BBadge,
    BCollapse,
  },
  // mixins: [mixinVerticalNavMenuGroup],
  props: {
    item: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      opened: false,
      clicked: false,
      first: true,
    }
  },
  mounted() {
    // console.log('nama route', this.$route.params.page)
    this.first = true
  },
  methods: {
    cekActive(item) {
      // console.log('data item', item)
      return this.cekOpen(item)
    },
    cekOpen(item, click = null) {
      const value = this.$route.params.page
      if (click === null) {
        return item.children.some(entry => {
          if (entry.children) {
            return this.cekOpen(entry)
          }
          if (entry.route.params.page !== value) {
            return this.opened
          }
          // console.log('status', this.first)
          if (this.first) {
            this.opened = true
            return true
          }
          this.opened = this.clicked
          return true
        })
      }
      this.opened = click
      return click
    },
    clickGroup(status) {
      this.first = false
      // console.log(this.clicked = !status)
      this.clicked = !status
      this.cekOpen(this.item, this.clicked)
      return this.clicked
    },
  },
  setup() {
    // const {
    //   updateGroupOpen,
    // } = useVerticalNavMenuGroup(props.item)

    const { t } = useI18nUtils()
    const { canViewVerticalNavMenuGroup } = useAclUtils()

    return {
      resolveNavItemComponent,
      // updateGroupOpen,
      // ACL
      canViewVerticalNavMenuGroup,
      // i18n
      t,
    }
  },
}
</script>

<style scoped>
/deep/ .main-menu.menu-light .navigation > li ul li ul a {
    padding: 10px 15px 10px 15px !important;
}
</style>
